import styled from 'styled-components';

export const OwnerDetails = styled.div `
  display: flex;
  align-items: center;
  font-family: 'Lato';
  font-weight: 400;
`;

export const OwnerImage = styled.img`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  margin-right: 6px;
  object-fit: contain;
`;

export const LabelWrapper = styled.p`
  display: flex;
  align-items: center;
`;

export const Name = styled.span`
  font-size: 14px;
  line-height: 16px;
  color: #008cff;
  font-family: 'Lato';
  font-weight: 900;
`;

export const Label = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-family: 'Lato';
  font-weight: 900;
`;

export const SubLabel = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #4a4a4a;
  font-family: 'Lato';
  font-weight: 400;
  margin-top: 4px;
`;